export default {
	computed: {
		profileImage() {
			if (this.me && this.me.cities && this.me.cities.length && this.me.cities[0].city_logo.length) {
				return this.me.cities[0].city_logo[0].full_url
			}
			return `https://api.dicebear.com/9.x/identicon/svg?seed=Robert`
		},
	}
}